export const AppModules = {
    Cards: "Cards",
    UserCards: "UserCards",
    CarCards: "Cards",
    Operations: "Operations",
    Limits: "Limits",
    Areas: "Areas",
    Tanks: "Tanks",
    TankOperations: "TankOperations",
    Administration: "Administration",
    ChangesHistory: "ChangesHistory"
}

export const AppFields = {
    EditExtendedIoList: "EditExtendedIoList"
}

export const AccessLevel = {
    None: 0,
    Read: 1,
    Write: 2
}